import React from 'react';
import { Box, Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

const ZipDownloadButton = ({ resizedImages, downloadAllAsZip }) => {
    if (resizedImages.length === 0) return null;

    return (
        <Box display="flex" justifyContent="center" my={2}>
            <Button 
                variant="contained" 
                color="primary" 
                onClick={downloadAllAsZip}
                startIcon={<DownloadIcon />}
            >
                一括ダウンロード（ZIP）
            </Button>
        </Box>
    );
};

export default ZipDownloadButton;
